export default __webpack_public_path__ + "static/media/playStore.f62b362c.png";